import styles from "./AuthorCard.module.scss";
import { RESPONSIVE_SIZES, SanityImage } from "../SanityImage";
import Link from "next/link";
import { AlgoliaAuthor } from "@repo/algolia/types";

type Props = {
  author: AlgoliaAuthor;
};

const AuthorCard: React.FC<Props> = ({ author }) => {
  const { name, image, slug, postsCount } = author;
  return (
    <Link href={slug} className={styles.title}>
      <article className={styles.container}>
        <header className={styles.header}>
          {image && (
            <SanityImage
              image={image}
              alt={name}
              aspectRatio="card"
              fill
              sizes={RESPONSIVE_SIZES["thumbnail"]}
              className={styles.image}
            />
          )}
        </header>

        <div className={styles.content}>
          <h4 className={styles.title}>{name}</h4>
          <div className={styles.articles}>{postsCount} articles</div>
        </div>
      </article>
    </Link>
  );
};

export default AuthorCard;
